import type {
    KEScore,
    PerseusRenderer,
    PerseusScore,
    UserInputMap,
} from "@khanacademy/perseus-core";
import {mapErrorToString} from "@khanacademy/perseus/strings";
import {RequestInfo} from "@khan/shared-core";

import {perseusStrings} from "./perseus-strings-lingui.tsx";
import {
    scorePerseusItem as perseusScorePerseusItem,
    ScoringUtil,
    type ServerItemRendererComponent,
} from "./perseus.ts";

/**
 * Helper to score a Perseus item without having
 * to think about strings and locale
 */
export default function scorePerseusItem(
    question: PerseusRenderer,
    userInput: UserInputMap,
): PerseusScore {
    const score = perseusScorePerseusItem(
        question,
        userInput,
        RequestInfo.kaLocale,
    );

    const errMessage = mapErrorToString(score.message, perseusStrings()) as any;
    return {...score, message: errMessage};
}

/**
 * This come from a place of fear. I don't think we need to
 * do the `maxCompatGuess` thing, but I can't figure out what might
 * be using this data so I'm trying to keep it the same as it was.
 */
export function convertScoreToKeScore(
    score: PerseusScore,
    renderer: ServerItemRendererComponent,
): KEScore {
    // Continue to include an empty guess for the now defunct answer area.
    // TODO(alex): Check whether we rely on the format here for
    //             analyzing ProblemLogs. If not, remove this layer.
    const maxCompatGuess = [renderer.getUserInputLegacy(), []];
    return ScoringUtil.keScoreFromPerseusScore(
        score,
        maxCompatGuess,
        renderer.questionRenderer.getSerializedState(),
    );
}
